export const FEATURE_NAME = '@zerops/zerops/feature/deletion-warning-dialog';
